export const BUTTON_TYPES = {
  textButton: 'textButton',
  button: 'button',
  node: 'node',
} as const;

export const SHOW_LABEL = {
  hover: 'hover',
  always: 'always',
} as const;

export const DATA_HOOKS = {
  item: 'accordion-item',
  header: 'header',
  toggleButton: 'accordion-toggle-button',
  toggleAccordionWrapper: 'toggle-accordion-wrapper',
  // TODO: mismatch for backwards compat, update when major
  prefix: 'icon',
  suffix: 'suffix',
  subtitle: 'accordion-item-subtitle',
} as const;

export const SKINS = {
  standard: 'standard',
  light: 'light',
  neutral: 'neutral',
} as const;

export const TITLE_SIZES = {
  small: 'small',
  medium: 'medium',
} as const;

export const SIZES = {
  xxTiny: 'xxTiny',
  xTiny: 'xTiny',
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export const HORIZONTAL_PADDINGS = {
  none: 'none',
  xxTiny: 'xxTiny',
  xTiny: 'xTiny',
  tiny: 'tiny',
  small: 'small',
  medium: 'medium',
  large: 'large',
} as const;

export const CONTENT_PADDINGS = {
  none: 'none',
} as const;

export const TRANSITION_SPEEDS = {
  slow: 'slow',
  medium: 'medium',
  fast: 'fast',
} as const;
